import SimpleStore, { combineReducers, useDispatch, useSelector } from './SimpleStore';
export default {
  SimpleStore: SimpleStore,
  combineReducers: combineReducers,
  useDispatch: useDispatch,
  useSelector: useSelector
};